import { Injectable } from '@angular/core';

import { delay, Observable, of } from 'rxjs';

import { CardProduct, Currencies, GetSkinsRes } from '@zeusm/business/core/entities';

import { BusinessDictionariesApi } from './dictionaries-api.interface';
import { mockCardProducts, mockGetSkinsRes } from '../mocks';
import { getCurrenciesMock } from '../mocks/dictionaries.mock';

@Injectable()
export class BusinessDictionariesApiMockService implements BusinessDictionariesApi {
  getCurrencies(): Observable<Currencies> {
    const currencies = getCurrenciesMock();

    return of(currencies).pipe(delay(500));
  }

  getSkins(): Observable<GetSkinsRes> {
    return of(mockGetSkinsRes).pipe(delay(200));
  }

  getCardProducts(): Observable<CardProduct[]> {
    return of(mockCardProducts).pipe(delay(200));
  }
}
